import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Container } from "semantic-ui-react";
import DashboardLayout from "src/components/Dashboard/DashboardLayout";
import { Navigation } from "src/components/Navigation";
import { withAuthorization } from "../../components/Session/withAuthorization";
const DashboardComponent = ({
  authUser,
  orgId,
  history,
  match,
  location,
  usersStatus,
}: any) => (
  <React.Fragment>
    <Navigation />
    <Container className="main-container">
      <DashboardLayout
        orgId={orgId}
        authUser={authUser}
        match={match}
        history={history}
        location={location}
        usersStatus={usersStatus}
      />
    </Container>
  </React.Fragment>
);

const mapStateToProps = (state: any) => ({
  authUser: state.sessionState.authUser,
  orgId: state.sessionState.orgId,
  usersStatus: state.sessionState.usersStatus,
});

const authCondition = (authUser: any) => !!authUser;

const Dashboard = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(withRouter(DashboardComponent));

export default Dashboard;



// WEBPACK FOOTER //
// ./src/containers/Dashboards/Dashboard.tsx